import { List, DataTable, ReferenceField, TextField } from "@/components/admin";
import { Badge } from "@/components/ui/badge";
import { useRecordContext } from "ra-core";

const TypeBadge = () => {
  const record = useRecordContext();
  if (!record) return null;

  const typeColors: Record<string, string> = {
    call: "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200",
    email:
      "bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200",
    note: "bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200",
    site_visit:
      "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200",
    status_change:
      "bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200",
  };

  const type = record.type as string;
  const label = type.replace(/_/g, " ");

  return (
    <Badge
      className={
        typeColors[type] ||
        "bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200"
      }
    >
      {label}
    </Badge>
  );
};

export const ActivityList = () => (
  <List perPage={1000} pagination={false}>
    <DataTable>
      <DataTable.Col source="id" label="ID" />
      <DataTable.Col label="Job">
        <ReferenceField source="job_id" reference="jobs">
          <TextField source="id" />
        </ReferenceField>
      </DataTable.Col>
      <DataTable.Col source="type" label="Type">
        <TypeBadge />
      </DataTable.Col>
      <DataTable.Col source="description" label="Description" />
      <DataTable.Col source="timestamp" label="Timestamp" />
    </DataTable>
  </List>
);
